import { injectIntl } from 'react-intl';
import { Dialog, ScreenMessagePanelContainer, Label, ButtonStandard, ButtonLight, formatMessage } from 'cw-ui-core';
import css from './DisableUserDialog.scss';
import layoutCss from 'src/styles/layout.scss';
import Locale from 'src/i18n';
import React from 'react';

export const DISABLE_USER_DIALOG = 'DISABLE_USER_DIALOG';

const DisableUserDialog = ({ onCancel, onOk, userCount }) => {
    const dialogButtons = [
        <ButtonLight
            key="cancel"
            automationName="cancel"
            className={css.cancelButton}
            value={formatMessage(Locale.cancel)}
            onClick={onCancel}
        />,
        <ButtonStandard
            key="ok"
            automationName="ok"
            className={css.disableButton}
            value={formatMessage(Locale.disable)}
            onClick={onOk}
        />,
    ];

    return (
        <Dialog dialogId={DISABLE_USER_DIALOG} header={formatMessage(Locale.disableUser)} buttons={dialogButtons}>
            <div className={css.wrap}>
                <div className={layoutCss.podCol}>
                    <ScreenMessagePanelContainer className={css.screenMessage} screenKey={DISABLE_USER_DIALOG} />
                    <Label value={formatMessage(Locale.disableUserConfirmation)} />
                    <div className={css.userCountText}>
                        {formatMessage(Locale.usersSelected, { usersCount: userCount })}
                    </div>
                </div>
            </div>
        </Dialog>
    );
};

export default injectIntl(DisableUserDialog);
